export type EditorSelectionKeyCategory = "vse" | "xrPin" | "figmaPlane" | null;

export function buildVseLockKey(
  spaceIndex?: number | null,
  vseIndex?: number | null,
): string | null {
  if (typeof spaceIndex !== "number" || typeof vseIndex !== "number") {
    return null;
  }

  return `vse:${spaceIndex}:${vseIndex}`;
}

export function buildXrPinLockKey(
  entryPointIndex?: number | null,
  vseIndex?: number | null,
): string | null {
  if (typeof entryPointIndex !== "number" || typeof vseIndex !== "number") {
    return null;
  }

  return `xr:${entryPointIndex}:${vseIndex}`;
}

export function buildFigmaPlaneLockKey(
  spaceIndex?: number | null,
  vseIndex?: number | null,
  hmiIndex?: number | null,
): string | null {
  if (
    typeof spaceIndex !== "number" ||
    typeof vseIndex !== "number" ||
    typeof hmiIndex !== "number"
  ) {
    return null;
  }

  return `figma:${spaceIndex}:${vseIndex}:${hmiIndex}`;
}

export function buildSelectionKey(
  category: EditorSelectionKeyCategory,
  detail?: object | null,
): string | null {
  const selectionDetail = detail as Record<string, unknown> | null | undefined;

  if (!category || !detail) return category;

  if (category === "figmaPlane") {
    return buildFigmaPlaneLockKey(
      typeof selectionDetail?.spaceIndex === "number"
        ? selectionDetail.spaceIndex
        : -1,
      typeof selectionDetail?.vseIndex === "number"
        ? selectionDetail.vseIndex
        : -1,
      typeof selectionDetail?.hmiIndex === "number"
        ? selectionDetail.hmiIndex
        : -1,
    );
  }

  if (category === "xrPin") {
    return buildXrPinLockKey(
      typeof selectionDetail?.entryPointIndex === "number"
        ? selectionDetail.entryPointIndex
        : -1,
      typeof selectionDetail?.vseIndex === "number"
        ? selectionDetail.vseIndex
        : -1,
    );
  }

  if (category === "vse") {
    return buildVseLockKey(
      typeof selectionDetail?.spaceIndex === "number"
        ? selectionDetail.spaceIndex
        : -1,
      typeof selectionDetail?.vseIndex === "number"
        ? selectionDetail.vseIndex
        : -1,
    );
  }

  return category;
}
